import { render, staticRenderFns } from "./LiveData.vue?vue&type=template&id=70d28b54&scoped=true&"
import script from "./LiveData.vue?vue&type=script&lang=ts&"
export * from "./LiveData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d28b54",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d28b54')) {
      api.createRecord('70d28b54', component.options)
    } else {
      api.reload('70d28b54', component.options)
    }
    module.hot.accept("./LiveData.vue?vue&type=template&id=70d28b54&scoped=true&", function () {
      api.rerender('70d28b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/LiveData.vue"
export default component.exports